import React from 'react'
import {ProfileFeedbackInfo} from '../../organism'
import ProfileStyled from './styled'

const ProfileProcesses = () => {
  return (
    <ProfileStyled>
      <ProfileFeedbackInfo/>
    </ProfileStyled>
  )
}

export default ProfileProcesses
